<div id="rd-loading" class="container-loading">
  <div class="bg-loader-initial d-inline-flex">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <span class="tx-waiting">Aguarde!</span>
  </div>
</div>
